import React, {useState} from "react";
import moment from "moment";
import {Calendar, momentLocalizer} from "react-big-calendar";
import {CustomEvent} from "./Events/CustomEvent";
import {EventWrapper} from "./Events/EventWrapper";
import {CreateAppointment} from "./Appointment/Create";
import {AppointmentDetails} from "./Appointment/Details";
import {isPastDate} from "../../utils/date";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./calendar.scss";

const localizer = momentLocalizer(moment);

const BusinessCalendar = ({events, refreshCalendar}) => {
  const [appointmentDetail, setAppointmentDetail] = useState({});
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showAppointmentDetail, setShowAppointmentDetail] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [currentView, setCurrentView] = useState("month");

  const createNewAppointment = ({start}) => {
    if (isPastDate(start)) {
      return;
    }
    setStartDate(start);
    setShowCreateForm(true);
  };

  const handleDrillDown = (date) => {
    // In month view, clicking a date opens the create modal instead of drilling down
    if (currentView === "month" && !isPastDate(date)) {
      setStartDate(date);
      setShowCreateForm(true);
    }
  };

  const dayPropGetter = (date) => {
    if (isPastDate(date)) {
      return {
        className: "past-date",
        style: {
          backgroundColor: "#f5f5f5",
          opacity: 0.6,
          cursor: "not-allowed"
        }
      };
    }
    return {};
  };

  const handleEventClick = (event) => {
    setAppointmentDetail(event);
    setShowAppointmentDetail(true);
  };

  return (
    <>
      {showCreateForm && (
        <CreateAppointment
          date={startDate}
          close={() => setShowCreateForm(false)}
          onSuccess={refreshCalendar}
        />
      )}
      {showAppointmentDetail && (
        <AppointmentDetails
          appointment={appointmentDetail}
          close={() => setShowAppointmentDetail(false)}
          onSuccess={refreshCalendar}
        />
      )}
      <Calendar
        selectable
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        view={currentView}
        onView={setCurrentView}
        onSelectSlot={createNewAppointment}
        onDrillDown={handleDrillDown}
        dayPropGetter={dayPropGetter}
        longPressThreshold={10}
        components={{
          eventWrapper: EventWrapper,
          event: ({event}) => (
            <CustomEvent
              event={event}
              onClick={() => handleEventClick(event)}
            />
          ),
        }}
      />
    </>
  );
};

export default BusinessCalendar;
